import React, {useState, useContext} from 'react';
import {truncate} from 'lodash';

import {CourseLessonsContext} from '../../components/CourseLessonsProvider';
import Button from '../../components/ButtonNew';
import {useAnalytics} from '../../hooks';
import devices from '../../../css/images/devices.png';

const cardsPerRow = 2;

const Card = ({course, currSlug}) => {
  const {tags} = useContext(CourseLessonsContext);
  const {tracker} = useAnalytics();
  const companyTag = tags?.company.find((c) => c.id === course.company);

  const handleClick = () => tracker.courseClickRelatedCourses({
    currentCourse: currSlug,
    clickedCourse: course.slug,
  });

  return (
    <div className="flex flex-row">
      <img
        className="p-2 mr-4 w-16 h-16 rounded shadow-md flex-shrink-0"
        src={companyTag?.image_url || devices.src}
        alt={course.title}
      />
      <div>
        <div className="my-1 text-sm font-bold">
          {course.shortTitle}
        </div>
        <div className="mt-3 mb-8 md:mb-10 text-sm font-medium text-gray-500">
          {truncate(course.description, {
            length: 120,
            separator: /[.,:;?!]? +/,
          })}
        </div>
        <Button href={`/courses/${course.slug}`} onClick={handleClick}>
          Start this course
        </Button>
      </div>
    </div>
  );
};

const RelatedCourses = ({currSlug, relatedCourses}) => {
  const [showAll, setShowAll] = useState(false);
  const {tracker} = useAnalytics();

  const handleShowMore = () => {
    tracker.courseClickShowMoreCourses();
    setShowAll((curr) => !curr);
  };

  return (
    <div className="px-3 md:px-12 lg:px-24">
      <div className="mb-8 text-xl font-bold">Related Courses</div>
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-16">
        {relatedCourses.map((course, i) => ((showAll || i < cardsPerRow)
          && <Card course={course} currSlug={currSlug} />
        ))}
      </div>
      <div className="my-6 ml-20">
        {relatedCourses.length > cardsPerRow && (
          <button
            className="text-indigo font-medium underline"
            onClick={handleShowMore}
            type="button"
          >
            {showAll ? 'Show less' : 'Show more'}
          </button>
        )}
      </div>
    </div>
  );
};

export default RelatedCourses;
